<template>
  <div class="snackbar-container" :class="[verticalClass, horizontalClass]">
    <transition-group name="list" tag="div">
      <v-alert
        v-for="snackbar in snackbars"
        :key="snackbar.uuid"
        :type="snackbar.type"
        class="elevation-10"
      >
        <v-row align="center">
          <v-col class="grow">
            {{ snackbar.message }}
          </v-col>
          <v-col v-if="snackbar.timeout <= 0" class="shrink">
            <v-btn icon v-on:click="closeItem(snackbar.uuid)"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-col>
        </v-row>
      </v-alert>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    top: Boolean,
    bottom: Boolean,
    left: Boolean,
    right: Boolean,
    center: Boolean,
  },
  computed: {
    ...mapGetters({
      snackbars: 'snackbars/all',
    }),
    verticalClass() {
      return this.left ? 'left' : this.right ? 'right' : 'center'
    },
    horizontalClass() {
      return this.top ? 'top' : 'bottom'
    },
  },
  methods: {
    closeItem(uuid) {
      this.$store.commit('snackbars/remove', uuid)
    },
  },
}
</script>

<style lang="scss" scoped>
.snackbar-container {
  position: fixed;
  // background: orange;
  // height: 500px;
  width: 300px;
  max-width: 100vw;
  z-index: 99999;

  display: flex;
  flex-direction: column;

  &.bottom {
    bottom: 0;
    flex-direction: column-reverse;

    &.center {
      margin-bottom: -16px;
    }
  }

  &.top {
    top: 0;
  }

  &.center {
    left: 50%;
    transform: translateX(-50%);
  }

  &.left {
    left: 0;
  }

  &.right {
    right: 0;
  }

  // > * {
  //   margin: 8px;
  // }

  ::v-deep .v-alert__content {
    .row .col {
      padding: 2px 12px;

      &.shrink .v-btn {
        margin: -8px -4px;
      }
    }
  }
}
</style>
